import type { NextPage } from 'next'
import Link from 'next/link'

import Title from '~/components/global/CTitle'
import { DefaultLayout } from '~/components/layout/Default'

const Ending: NextPage = () => {
    return (
        <DefaultLayout pageTitle={'楽曲情報'}>
            <div className="mt-12 md:mt-14 max-w-6xl w-[90vw] mx-auto">
                <Title src="/images/title/music.svg" title={'楽曲情報'} subtitle />
                <div className="py-8 md:py-16 px-4 lg:px-44 md:px-12 bg-[#ffff00b3] mt-10">
                    <div className="text-center border-t border-b border-c-secondary p-6">
                        <p className="text-c-primary font-bold">第一期エンディングテーマ</p>
                        <h2 className="text-2xl font-RocknRoll">「Reflexion」</h2>
                        <div className="w-40 h-2 mx-auto -mt-[8px]  bg-c-secondary" />
                        <p className="text-lg mt-2 font-RocknRoll">SpendyMily</p>
                    </div>
                    <div className="mx-auto mt-8 flex justify-center">
                        <img src="/images/music/cd-reflexion.png" alt="reflexion" />
                    </div>
                </div>
                <div className="py-8 md:py-16 px-4 lg:px-44 md:px-12 bg-[#ffff00b3] mt-10">
                    <div className="text-center border-t border-b border-c-secondary p-6">
                        <p className="text-c-primary font-bold">アーティスト</p>
                        <h2 className="text-2xl font-RocknRoll">「SpendyMily」</h2>
                        <div className="w-48 h-2 mx-auto -mt-[8px]  bg-c-secondary" />
                    </div>
                    <div className="mx-auto mt-8 flex justify-center">
                        <img src="/images/music/reflexion.jpg" alt="SpendyMily" />
                    </div>
                    <div className="mt-12 leading-8">
                        <p>
                            2020年、Vo.松永瀀がyukirie、平井⽂と出会いオンラインでのセッション活動をスタートし結成。叙情的かつハイテクニックなyukirieのギターを中⼼とし、
                            既存の枠組みに捉われないアレンジを追求する事で、インターネットシーンにおいて国内外問わず幅広い⾳楽ファンからの⾼評価を獲得している。
                        </p>
                    </div>
                    <h3 className="mt-4 text-lg font-RocknRoll">アーティストコメント</h3>
                    <div className="w-44 h-2 mr-auto -mt-[8px] bg-c-secondary" />
                    <div className="mt-2 leading-8">
                        <p>この度、「惑星のさみだれ」のエンディングテーマを担当させていただくこととなり、大変嬉しく思います！</p>
                        <p className="md:mt-6 mt-4">
                            原作を読んで、頭の中でどんなアニメになるのかを想像しながら、世界観に寄り添えるように歌詞を書かせていただきました。
                        </p>
                        <p className="md:mt-6 mt-4">「光を掴んでいつまでも君思う」「消えるあの日の青」</p>
                        <p className="md:mt-6 mt-4">
                            など、散りばめられた対照的な言葉によって人間の光と影を表現しているので、そこにも注目して頂けたらなと思います。
                        </p>
                        <p className="md:mt-6 mt-4">
                            アニメ「惑星のさみだれ」と共に 僕達SpendyMily 「Reflexion」も一緒に楽しんでいただけると嬉しいです！
                        </p>
                        <p className="md:mt-6 mt-4">SpendyMily 松永瀀</p>
                    </div>
                </div>
                <div className="text-c-secondary text-center md:mt-12 mt-8 font-RocknRoll md:text-4xl text-xl">
                    <Link href={'./'}>一覧にもどる</Link>
                </div>
            </div>
        </DefaultLayout>
    )
}

export default Ending
